module.exports = __webpack_public_path__ + "static/media/logo1.75114b7b.svg";